const hiddenUniframeRoutes = [
  '/app/user/auto-ban-account',
  '/app/user/auto-ban-account/',
  '/user-feedback',
  '/notifications',
];

export function appLayoutAdapter(isTrue?: boolean) {
  document.body.style.minWidth = '100vw';
  const usFeWrapper: any = document.querySelector('.by-us-fe-wrapper');
  const uniframeHeader: any = document.querySelector(
    '#__bybit_uniframe_header__',
  );
  const uniframeFooter: any = document.querySelector(
    '#__bybit_uniframe_footer__',
  );
  if (usFeWrapper) {
    usFeWrapper.style.minHeight = '0px';
  }
  const pathname = location.pathname.startsWith('/app')
    ? location.pathname
    : location.pathname.replace(/^\/[a-z]{2,3}(-[A-Z]{2,3})?/, '');
  if (hiddenUniframeRoutes.includes(pathname)) {
    if (uniframeHeader) {
      uniframeHeader.style.display = 'none';
    }
    if (uniframeFooter) {
      uniframeFooter.style.display = 'none';
    }
  }
}

export function webLayoutAdapter() {
  document.body.style.minWidth = '1370px';
  const uniframeHeader: any = document.querySelector(
    '#__bybit_uniframe_header__',
  );
  const uniframeFooter: any = document.querySelector(
    '#__bybit_uniframe_footer__',
  );
  if (uniframeHeader) {
    uniframeHeader.style.display = 'block';
  }
  if (uniframeFooter) {
    uniframeFooter.style.display = 'block';
  }
}

const h5ShowHeaderFooterPage = [
  '/app/user/recomment-buy-coin',
  '/notifications',
  '/notifications-setting',
  '/user-feedback',
  '/unsubscribe',
];

export function adapterH5(type: string) {
  const pathname = location.pathname.startsWith('/app')
    ? location.pathname
    : location.pathname.replace(/^\/[a-z]{2,3}(-[A-Z]{2,3})?/, '');
  if (type === 'header' && h5ShowHeaderFooterPage.indexOf(pathname) === -1) {
    if (window.innerWidth < 768) {
      (document.querySelector('#__bybit_uniframe_header__') as any).style =
        'display:none';
    }
  }
  if (type === 'footer' && h5ShowHeaderFooterPage.indexOf(pathname) === -1) {
    if (window.innerWidth < 768) {
      (document.querySelector('#__bybit_uniframe_footer__') as any).style =
        'display:none';
    }
  }
}
